import { Component, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { xpoDateFormatter } from '../../../../../../formatters';
import { XpoConditionBase } from '../../../../validations/validations.class';
import { XpoFilterCondition } from '../../../condition';
import { filterFormats, Operators, OperatorText, XpoFilterConditionCriteria } from './../../../../../models/index';

@Component({
  templateUrl: './after-same.component.html',
  styleUrls: ['../../validator.scss'],
})
export class XpoConditionDateAfterSameComponent extends XpoConditionBase implements XpoFilterCondition {
  static text: string = OperatorText.OnOrAfter;
  static operator = Operators.OnOrAfter;

  isNegative = false;
  model: string = '';

  @Output() inputChanged = new EventEmitter();

  constructor() {
    super(filterFormats.default);
  }

  validate(cellValue): boolean {
    // Do not validate if input is empty
    if (!this.model) {
      return true;
    }

    if (!cellValue) {
      return false;
    }

    return moment(cellValue)
      .startOf('day')
      .isSameOrAfter(moment(this.model).startOf('day'));
  }
  getCriteria(): XpoFilterConditionCriteria {
    return {
      operator: Operators.OnOrAfter,
      value: this.model,
      display: xpoDateFormatter({ value: moment(this.model).startOf('day') }),
    };
  }
  onInputChange(): any {
    this.validateFormat();
    this.inputChanged.emit(this.model);
  }
}
